/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxMinDto } from '../../models/backend-tax-min-dto';
import { BackendTaxMinRequestDto } from '../../models/backend-tax-min-request-dto';

export interface ProjectTaxesTaxMinUpdate$FormData$Params {
  id: number;
  body: BackendTaxMinRequestDto;
}

export function projectTaxesTaxMinUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxMinUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxMinDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxMinUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxMinDto>;
    }),
  );
}

projectTaxesTaxMinUpdate$FormData.PATH = '/api/project_taxes/tax_min/{id}/';
